import styled from 'styled-components';

export const SimuladorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
